import content from "../generated/content.json";

export const tracks = content.tracks;

export function getTrack(trackId) {
  return tracks.find((track) => track.id === trackId) || null;
}

/** Every level of a track in study order, annotated with its chapter. */
export function listLevels(track) {
  return track.chapters.flatMap((chapter) =>
    chapter.levels.map((level) => ({ level, chapter })),
  );
}

/** Locate a level and its neighbours inside a track. Returns null when it does not exist. */
export function findLevel(track, levelId) {
  const all = listLevels(track);
  const index = all.findIndex((entry) => entry.level.id === levelId);
  if (index === -1) return null;
  return {
    ...all[index],
    index,
    total: all.length,
    previous: all[index - 1]?.level || null,
    next: all[index + 1]?.level || null,
  };
}

/** Unique concepts taught by a list of levels, in first-seen order. */
export function conceptsOf(levels) {
  return [...new Set(levels.flatMap((level) => level.concepts || []))];
}
